import { render, staticRenderFns } from "./AllocatedBackorderHistoryContainer.vue?vue&type=template&id=23fc70d0&scoped=true&"
import script from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedBackorderHistoryContainer.vue?vue&type=style&index=0&id=23fc70d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc70d0",
  null
  
)

export default component.exports